/**
 * Dependencies.
 */
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

/**
 * Component.
 */
@Component({ name: 'order-steps-component' })
export default class extends Vue {
  /**
   * Property `total`.
   */
  @Prop({ default: 3 })
  total: number | string;

  /**
   * Property `steps`.
   */
  @Prop({ type: Object })
  step: {
    completed: boolean;

    number: number;
  };

  /**
   * Getter `currentStep`.
   */
  get currentStep() {
    const { number } = this.step || {};

    return number;
  }

  /**
   * Getter `isCurrentStepCompleted`.
   */
  get isCurrentStepCompleted() {
    const { completed } = this.step || {};

    return completed;
  }
}
